import { Stepper } from '@mint-lib/tw-components/patterns';

import type { DataFileServerStepNames } from '../../api/types.js';
import { useDataFileContext } from '../../contexts/DataFileContext/useDataFileContext.js';
import {
  useDataConfigurationErrorsCount,
  useDataFileServerStepsConfig,
  useTableDataFileTotalErrorsCount,
} from '../../queries/index.js';

export const DataFileStepper = () => {
  const { dataFilePreview } = useDataFileContext();

  const { id, currentStep } = dataFilePreview;

  const { data: validationErrorsCount } = useTableDataFileTotalErrorsCount(id, {
    enabled: false,
  });
  const { data: dataConfigurationErrorsCount } =
    useDataConfigurationErrorsCount(id, { enabled: false });

  const stepsErrors: Record<DataFileServerStepNames, boolean> = {
    upload: false,
    headers_mapping: false,
    validation: Boolean(validationErrorsCount?.totalErrors),
    channel_assignment: Boolean(dataConfigurationErrorsCount),
    success: false,
  };

  const serverStepsConfig = useDataFileServerStepsConfig(id);
  const currentStepConfig = serverStepsConfig[currentStep];
  const visibleSteps = serverStepsConfig.getVisibleSteps();
  const completedSteps = Object.fromEntries(
    Array.from({ length: currentStepConfig.index }, (_, index) => [
      index,
      true,
    ]),
  );

  return (
    <Stepper
      steps={visibleSteps}
      completedStep={completedSteps}
      activeStep={currentStepConfig.index}
      isStepFailed={(stepIndex) =>
        stepsErrors[serverStepsConfig[stepIndex].name]
      }
      className="mb-6 w-full grow-0"
    />
  );
};
